import { subscribeList,topicCount,getMeta } from '../../service'

const attention_mixins = {
  data() {
    return {
      recommend_tag_map: [],
      entity_ntag: [],
      // 新增主题变量
      get_collection: [],
      zt_list_no: [], // 未关注的主题列表
      zt_list: [],
      // 新增机构宣传卡片变量
      org_modal_img: 'cksl',
      org_modal_p: '如果您有需求，可联系我们工作人员'
    }
  },
  computed: {
    attention() {
      return this.$store.state.attention
    },
    subscribe_tag() {
      if(this.attention.subscribe){
        let sub = this.attention.subscribe, s_arr = []
        sub.map((a) => {
          if(a.sub_type == '2') {
            s_arr.push(a.sub_type_id)
          }
        })
        return s_arr
      }else{
        return []
      }
    },
    topic_tag_count() {
      return this.$store.state.topic_tag_count
    },
    topic_entity_count() {
      return this.$store.state.topic_entity_count
    },
    topic_comp_count() {
      let arr = []
      if(this.topic_entity_count && this.attention.subscribe){
        arr = this.topic_entity_count.filter(item => {
          let index = this.attention.subscribe.findIndex(a => a.sub_type_id == item.id)
          return index > -1 && item.type == 0
        })
      }
      return arr
    },
    topic_org_count() {
      let arr = []
      if(this.topic_entity_count){
        arr = this.topic_entity_count.filter(item => {
          let index = this.attention.subscribe.findIndex(a => a.sub_type_id == item.id)
          return index > -1 && item.type == 1
        })
      }
      return arr
    },
    user_key() {
      return this.$store.state.user_key
    },
    yz_group() {
      return this.$store.state.yz_group
    },
    user() {
      if(this.$store.state.user !== '' && typeof this.$store.state.user === 'string') {
        return JSON.parse(this.$store.state.user)
      } else {
        return this.$store.state.user
      }
    },
    isVIP() {
      if(this.user) {
        return this.user.db_vip === '1' || this.user.vip === '1'
      } else {
        return false
      }
    }
  },
  methods: {
    /**
    * 按需获取元数据
    */
    async getMeta(cb) {
      let res = await getMeta({
        name: ['recommend_tag_map', 'entity_ntag', 'getcollection']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'recommend_tag_map', res.meta.recommend_tag_map)
        this.$set(this.$data, 'entity_ntag', res.meta.entity_ntag)
        this.get_collection = res.meta.getcollection
        this.refreshZtList()
        if(cb) cb()
      } else {
        this.$Message.error(res.message)
      }
    },
    haddleSetAtten1(all_or_group, all_select) {
      if(this.user_key){
        this.$router.push({ name: 'AttentionIndex' ,query: {type: all_or_group, select: all_select}})
      }else{
        this.login()
      }
    },
    haddleSetAtten2(group_id) {
      if(this.user_key){
        this.$router.push({ name: 'AttentionIndex' ,query: {active: group_id}})
      }else{
        this.login()
      }
    },
    haddleSetAtten3(yz_group_id) {
      if(this.user_key){
        this.$router.push({ name: 'AttentionIndex' ,query: {yz_group: yz_group_id}})
      }else{
        this.login()
      }
    },
    // 获取关注信息
    async getSubscribeList(callBack) {
      let res = await subscribeList({user_key: this.user_key},(error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$store.commit('updateFilter', {
          g_relation:res.g_relation,
          group:res.group,
          subscribe:res.subscribe
        })
        if(callBack) callBack()
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getAttentionCount() {
      let res = await topicCount({user_key: this.user_key, count_type: 'entity'},(error) => {
        console.log('请求错误！')
      })
      if(res.status == 'success') {
        this.$store.commit('topicEntityCount', res.res)
      }

      let res4 = await topicCount({user_key: this.user_key, count_type: 'tag'},(error) => {
        console.log('请求错误！')
      })
      if(res4.status == 'success') {
        this.$store.commit('topicTagCount', res4.res)
      } else {
        console.log(res4.msg)
      }
    },
    handleMoreEntity(router_name, keyword) {
      this.$router.push({name: router_name, query: {keyword: keyword}})
    },
    refreshZtList() { // 刷新主题分组
      this.zt_list_no = []
      this.zt_list = []
      this.zt_list_no = this.get_collection.reduce((val, item, index) => {
        let temp_obj_no = val.find((i) => i.id == item.id)
        let temp_obj = this.zt_list.find((i) => i.id == item.id)
        if(temp_obj_no) {
          if(!this.$store.state.attention.subscribe.some(i => i.sub_type == '100' && i.sub_type_id == temp_obj_no.id)) {
            temp_obj_no.entitys.push({id: item.content_id, type: item.content_type})
          } 
        } else {
          if(!this.$store.state.attention.subscribe.some(i => i.sub_type == '100' && i.sub_type_id == item.id)) {
            item['entitys'] = [{id: item.content_id, type: item.content_type}]
            val.push(item)
          } 
        }
        if(temp_obj) {
          if(this.$store.state.attention.subscribe.some(i => i.sub_type == '100' && i.sub_type_id == temp_obj.id)) {
            temp_obj.entitys.push({id: item.content_id, type: item.content_type})
          } 
        } else {
          if(this.$store.state.attention.subscribe.some(i => i.sub_type == '100' && i.sub_type_id == item.id)) {
            item['entitys'] = [{id: item.content_id, type: item.content_type}]
            this.zt_list.push(item)
          } 
        }
        return val
      }, [])
      this.$set(this.$data, 'zt_list_no', this.zt_list_no)
      this.$set(this.$data, 'zt_list', this.zt_list)
    },
    createGroupLimt(cb, closeM) { // 创建分组限制
      if(this.user_key) {
        console.log(this.isVIP)
        if(this.isVIP) {
          if(this.attention.group.length>=10) {
            if('org_modal' in this.$refs) {
              this.$refs['org_modal'].goShow()
              this.org_modal_img = 'szgz'
              this.org_modal_p = 'VIP用户支持10个分组。如果您有需求，可联系我们工作人员'
            } else {
              this.$Message.info('VIP用户支持10个分组。如果您有需求，可联系我们工作人员')
            }
            if(closeM) {
              closeM()
            }
            return
          } else {
            cb()
          }
        } else {
          if(this.attention.group.length>=5) {
            if('org_modal' in this.$refs) {
              this.$refs['org_modal'].goShow()
              this.org_modal_img = 'szgz'
              this.org_modal_p = '普通用户支持5个分组。如果您有需求，可联系我们工作人员'
            } else {
              this.$Message.info('普通用户支持5个分组。如果您有需求，可联系我们工作人员')
            }
            if(closeM) {
              closeM()
            }
            return
          } else {
            cb()
          }
        }
      } else {
        this.login()
      }
    },
    findZtEntityUid(id){ // 快讯列表查找主题下面的实体de uid
      let temp_obj = this.topic_entity_count.find(item => item.id == id)
      return temp_obj?temp_obj.uid:''
    },
    findZtEntity(id){ // 快讯列表查找主题下面的实体
      let temp_obj = this.topic_entity_count.find(item => item.id == id)
      return temp_obj?(temp_obj.short_name+'('+temp_obj.num+')'):'--'
    }
  }
}

export { attention_mixins }
